import React from 'react';
import { FormattedMessage } from 'react-intl';

import HashNavigation from '../lib/navigation.js';

function assetUrl(relativePath) {
  try {
    return new URL(relativePath, document.baseURI).href;
  } catch (_) {
    return relativePath;
  }
}

export default class ChatLoadingView extends React.PureComponent {
  render() {
    const { path } = HashNavigation.parseUrlHash(window.location.hash);
    const showDaxMessage = path[0] === 'dax';
    // Match applyCaxDaxTheme: dax → dark illustration, cax/default → light.
    const isDark = document.documentElement.classList.contains('theme-dark');
    const illustrationSrc = assetUrl(isDark ? 'img/loading-chat.png' : 'img/loading-light.png');

    return (
      <div className="chat-loading-view">
        <img
          src={illustrationSrc}
          alt=""
          className="chat-loading-view-illustration"
        />
        <p className="chat-loading-view-text">
          {showDaxMessage ?
            <FormattedMessage
              id="chat_loading_message"
              defaultMessage="Sandali lang...nilo-load pa ang message"
              description="Message shown while chat messages are loading"
            /> :
            <FormattedMessage
              id="chat_loading_message_cax"
              defaultMessage="Getting your message ready...{br}Please wait"
              description="Loading message shown on non-DAX views"
              values={{ br: <br /> }}
            />}
        </p>
      </div>
    );
  }
}
